import global from "../config/global";
import request from "../secrets-web/src/utils/request";
import workspace from '../secrets-web/src/services/workspace';

function create(data = {}) {
  return request({
    url: global.endpoint.WORKSPACES,
    method: "post",
    data
  });
}

function create_multiple(id, data = {}) {
  return request({
    url: global.endpoint.WORKSPACE_CREATE_MULTIPLE.replace(':id', id),
    method: "post",
    data
  });
}

export default {
  ...workspace,
  create,
  create_multiple
};
